import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import {
  ConversionOverview,
  ActivityLog,
  ActivityLogParams,
  StorePerformance,
  StorePerformanceParams,
  TopStore,
  TopStoreParams,
} from './conversionAnalytics.types';

export interface ConversionOverviewParams {
  clubId?: string;
  channel?: string;
}

const getConversionOverview = (client: AxiosInstance) => async (params: ConversionOverviewParams) => {
  return (await client.get<ApiResponse<ConversionOverview>>('/get-overview', { params })).data;
};

const getStorePerformance = (client: AxiosInstance) => async (params: StorePerformanceParams) => {
  return (await client.get<PaginatedApiResponse<StorePerformance[]>>('/get-store-performance', { params })).data;
};

const getActivityLog = (client: AxiosInstance) => async (params: ActivityLogParams) => {
  return (await client.get<PaginatedApiResponse<ActivityLog[]>>('/get-activity-log', { params })).data;
};

const getTopStoreList = (client: AxiosInstance) => async (params: TopStoreParams) => {
  return (await client.get<ApiResponse<TopStore[]>>('/get-top-store-list', { params })).data;
};

export const conversionAnalyticsQueries = {
  all: () => ['conversion analytics'],
  conversionOverview: (params: ConversionOverviewParams = {}) =>
    queryFactoryOptions<ApiResponse<ConversionOverview>>({
      queryKey: [...conversionAnalyticsQueries.all(), 'overview', params],
      queryFn: (client) => () => getConversionOverview(client)(params),
    }),
  storePerformance: (params: StorePerformanceParams) =>
    queryFactoryOptions<PaginatedApiResponse<StorePerformance[]>>({
      queryKey: [...conversionAnalyticsQueries.all(), 'store-performance', params],
      queryFn: (client) => () => getStorePerformance(client)(params),
    }),
  activityLog: (params: ActivityLogParams) =>
    queryFactoryOptions<PaginatedApiResponse<ActivityLog[]>>({
      queryKey: [...conversionAnalyticsQueries.all(), 'activity-log', params],
      queryFn: (client) => () => getActivityLog(client)(params),
    }),
  topStoreList: (params: TopStoreParams) =>
    queryFactoryOptions<ApiResponse<TopStore[]>>({
      queryKey: [...conversionAnalyticsQueries.all(), 'top-store-list', params],
      queryFn: (client) => () => getTopStoreList(client)(params),
    }),
};
